import { jsx as _jsx } from "react/jsx-runtime";
export function SvgImage({ href, x, y, width, height, transform, fill, stroke, }) {
    return (_jsx("image", { href: href, width: width, height: height, x: x, y: y, transform: transform, fill: fill, stroke: stroke }));
}
